import React from 'react';

const TextFormGroup = ({label, isRequired, name, value, onChange}) => {
    return (
        <div className="form-group">
            <label htmlFor={name} className="control-label col-md-4">
                {label}{isRequired ? '*' : ''}
            </label>
            <div className="col-md-8">
                <input type="text"
                       id={name}
                       name={name}
                       value={value}
                       className="form-control"
                       onChange={(e) => onChange(e.target.value)}/>
            </div>
        </div>
    );
}

export default TextFormGroup;